import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { eventActionTrigger } from '@telus/koodo-analytics-scripts';
import { TextButton } from '@telus-uds/components-web';
import Drawer from '../Drawer/Drawer';
import { RichText } from './RichText';
var EmbeddedDrawer = function (props) {
    var _a, _b, _c;
    var node = props.node, paragraphSize = props.paragraphSize;
    var triggerRef = useRef(null);
    var buttonRef = useRef(null);
    var drawerData = node.data.target;
    var footer = ((_a = drawerData.footer) === null || _a === void 0 ? void 0 : _a.fieldRichText) ? (_jsx(RichText, { content: drawerData.footer.fieldRichText })) : undefined;
    var analytics = drawerData === null || drawerData === void 0 ? void 0 : drawerData.analyticsEvent;
    return (_jsxs(_Fragment, { children: [_jsx(TextButton, { variant: { size: paragraphSize }, ref: buttonRef, onPress: function () {
                    var _a;
                    (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.openDrawer();
                    if (analytics) {
                        eventActionTrigger({
                            name: analytics.name,
                            action: 'click',
                            details: analytics.details
                        });
                    }
                }, children: node.data.target.linkText.fieldText }), _jsx(Drawer, { heading: (_b = drawerData.title) === null || _b === void 0 ? void 0 : _b.fieldText, ref: triggerRef, triggerElements: buttonRef, footer: footer, children: _jsx(RichText, { content: (_c = drawerData.description) === null || _c === void 0 ? void 0 : _c.fieldRichText }) })] }));
};
export default EmbeddedDrawer;
